import * as signalR from "@microsoft/signalr";

const HUB_URL = "https://gateway.megriva.com/pay-hub";

export async function connectPayHub({ providerReference, onMessage }) {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, {
      transport: signalR.HttpTransportType.WebSockets,
      withCredentials: true,
    })
    .withAutomaticReconnect()
    .build();

  connection.on("Receive", (data) => {
    onMessage?.(data);
  });

  await connection.start();
  await connection.invoke("RegisterTransaction", providerReference);

  return connection;
}